// TODO document this file!

// TODO organise this better

import { AiFillAlert, AiFillDatabase, AiFillPieChart, AiOutlineAreaChart, AiOutlineLineChart } from "react-icons/ai";
import { MdAccountBalance, MdCompost, MdDashboard, MdRadar, MdTrackChanges } from "react-icons/md";
import { FaBalanceScale, FaBookOpen, FaLuggageCart, FaTruck, FaUserCog } from "react-icons/fa";
import {
  BsCollectionFill,
  BsFillBarChartFill,
  BsFillGearFill,
  BsPassFill,
  BsPatchExclamationFill,
  BsPieChartFill,
} from "react-icons/bs";
import { ChartBarHorizontal, ChartPie, GearSix, NotePencil, Planet, Question, TreeStructure, Truck } from "@phosphor-icons/react";
import { HiUsers } from "react-icons/hi";
import { HiMiniCog, HiMiniSquaresPlus, HiMiniDocumentText, HiMiniCalendarDays } from "react-icons/hi2";
import { GrNotes } from "react-icons/gr";
import { RiProgress3Fill } from "react-icons/ri";
import { GoFileMedia } from "react-icons/go";
import {
  Dashboard,
  NetZeroStrategy,
  OrganisationQuestionnaires,
  OrganizationQuestionnaireWrapper,
  SupplierAdminDashboard,
  SupplierEmissionsReport,
  SupplierNetZeroStrategy,
  SupplierNotes,
  SupplierQuestionnaire,
  SupplierQuestionnaires,
  SupplierResources,
  SupplierSettings,
  SuppliersLocations,
  SupplierUserNotes,
  SupplierData,
  SupplierDetail,
  SupplierTaskDetail,
  TaskAssigneesTemplate,
} from "../pages";
import { ChakraProvider, Text } from "@chakra-ui/react";
import { PhysicalRisk } from "../pages/PhysicalRisk";
import { SupplierPhysicalRiskQuestionnaire } from "../pages/SupplierPhysicalRiskQuestionnaire";
import { SupplierDashboard } from "../pages/SupplierDashboard";
import ESGExplorer from "../pages/ESGExplorer/ESGExplorer";
import {
  CarbonPrice,
  ClimateActionTracker,
  ClimatePolicyRadar,
  ExposureToLitigation,
  MaterialIssuesAndIndicators,
  SustainableFinanceRegulation,
} from "../pages/ScenarioPlanning/components";
import { t } from "i18next";
import { Navigate } from "react-router-dom";
import { ConversionFactors, MultimodalTransportation, Users, Prompts, DimensionManagementPage, ScopeTwoEngine, ModelCatalog, AIUsage, AIStatus, FinancialYearSettings } from "../pages/Settings";
import EntityPage from "pages/Settings/Entities/EntityPage";
import { EmissionsReports } from "../pages/Reports/EmissionsReports";
import { SupplierReports } from "../pages/Reports/SupplierReports";
import { OrganizationPlanning } from "../pages/DataEntryPlanning/components/OrganizationPlanning";
import DataEntryPlanningPage from "../pages/DataEntryPlanning/components/OrganizationPlanning/DataEntryPlanningPage";
import AddDataPage from "../pages/DataEntryPlanning/components/OrganizationPlanning/AddDataPage";
import { SuppliersPlanning } from "../pages/DataEntryPlanning/components/SuppliersPlanning";
import { carbonDioxideSvgIcon, netZeroStrategySvgIcon } from "../utils";
import { SupplierManagement } from "../pages/SupplierManagement";
import { SuppliersEmissionsDashboard } from "../pages/SuppliersEmissionsDashboard";
import { CompanyEmissionsDashboard } from "../pages/Reports/CompanyEmissionsDashboard";
import CSRDPlanning from "../pages/CSRD/CSRDPlanning/CSRDPlanning";
import { CSRDQuestionnaires } from "../pages/CSRD/CSRDQuestionnaires";
import { CSRDReport } from "../pages/CSRD/CSRDReport";
import CSRDQuestionnaireWrapper from "../pages/CSRD/CSRDQuestionnaire/CSRDQuestionnaireWrapper";
import { CSRDViewProgress } from "../pages/CSRD/CSRDViewProgress";
import { AllNotification } from "../components/Nofitication/AllNotification";
import EsgTheme from "../theme";
import IssbQuestionnaireRoundEditorPage from "../pages/ISSB/QuestionnaireRound/IssbQuestionnaireRoundEditorPage";
import IssbStageSetupPage from "../pages/ISSB/QuestionnaireRound/components/IssbStageSetupPage";
import AnswerDetailPage from "../pages/ISSB/IssbDataInput/AnswerDetailPage";
import InviteTeamPage from "../pages/ISSB/Onboarding/InviteTeamPage";
import DataInputPage from "../pages/ISSB/IssbDataInput/DataInputPage";
import IssbStartAudit from "../pages/ISSB/Audit/IssbStartAudit";
import IssbRequirementsPage from "../pages/ISSB/Requirements/IssbRequirementsPage";
import IssbTemplatePackagePage from "pages/ISSB/IssbTemplatePackagePage";
import IssbTemplateQuestionListPage from "pages/ISSB/IssbTemplateQuestionListPage";
import AuditControlPage from "../pages/ISSB/Audit/AuditControlPage";
import CompareAIReviewsPage from "../pages/ISSB/Compare/CompareAIReviewsPage";
import ReportDocListPage from "../pages/ISSB/ReportDocListPage";
import ReportDocEditorPage from "../pages/ISSB/ReportDocEditorPage";
import IssbCompleteAudit from "../pages/ISSB/Audit/IssbCompleteAudit";
import IssbPlanPublic from "../pages/IssbPlan/IssbPlanPublic";
import IssbDashboard from "../pages/ISSB/Dashboard/IssbDashboard";
import SourcesListPage from "pages/ISSB/Sources/SourcesListPage";
import AIReviewPage from "pages/ISSB/AIReview/AIReviewPage";
import AITasksListPage from "pages/ISSB/AITasks/AITasksListPage";
import AISettingsPage from "pages/ISSB/AISettingsPage";
import AboutAppPage from "pages/AboutAppPage";
import HelpPage from "pages/Help/HelpPage";
import OrganizationList from "../pages/OrgMgmt/OrganizationList";
import OrganizationPage from "../pages/OrgMgmt/OrganizationPage";
import CompletedAuditInfo from "../pages/ISSB/Audit/components/CompletedAuditInfo";
import AgenticDashboard from "../pages/AgenticDashboard/AgenticDashboard";
import IssbTemplateQuestionEditorPage from "../pages/ISSB/IssbTemplateQuestionEditorPage";
import EmissionsInsights from "../pages/Reports/Insights/EmissionsInsights";
import SupplierInsights from "../pages/Reports/Insights/SupplierInsights";
import SupplierInsightEmissionDetail from "../pages/Reports/Insights/supplier-components/SupplierInsightEmissionDetail";
import SupplierIndividualDetail from "../pages/Reports/Insights/supplier-components/SupplierIndividualDetail";
import SupplierProductDetail from "../pages/Reports/Insights/supplier-components/SupplierProductDetail";
import MODULES from "./modules";
import SupplierEngagement from "../pages/Reports/Insights/supplier-engagement/SupplierEngagement";
import FoundationDataV2Page from "../pages/ISSB/FoundationDataV2/FoundationDataV2Page";
import FoundationChatPage from "../pages/ISSB/FoundationDataV2/Chat/FoundationChatPage";
import FoundationYearDetailPage from "../pages/ISSB/FoundationDataV2/FoundationYearDetailPage";
import AiDataMappingPage from "../pages/aiDataMapping";
export const baseRoute = "/app";

export const companyEmissionsDashboardKey = "reportingPortalCompanyEmissionsDashboard";
export const netZeroStrategyKey = "netZeroStrategy";
export const supplierAdminDashboardKey = "supplierPortalSupplierDashboard";

/**
 * route-name -to-> route-path
 * 
 * Naming convention going forward:
 * 
The path `/{module}/{pageName}` with route name `{pageName}` should map to the page file `{page}Page.jsx`

This hasn't been followed historically -- let's move to this convention going forward, refactoring as we go.
 */
export const routes = {
  agenticDashboard: `${baseRoute}/agentic-dashboard`,
  dashboard: `${baseRoute}/dashboard`,
  [netZeroStrategyKey]: `${baseRoute}/net-zero-strategy`,

  reportingPortal: `${baseRoute}/reporting-portal`,
  [companyEmissionsDashboardKey]: `${baseRoute}/reporting-portal/company-emissions-dashboard`,
  reportingPortalCompanyReports: `${baseRoute}/reporting-portal/company-reports`,
  reportingPortalPhysicalRisk: `${baseRoute}/reporting-portal/physical-climate-risk`,
  reportingPortalInsights: `${baseRoute}/reporting-portal/insights`,
  reportingPortalSupplierInsights: `${baseRoute}/reporting-portal/supplier-insights`,
  supplierInsightEmissionDetail: `${baseRoute}/reporting-portal/supplier-insights/emission-detail`,
  supplierInsightsIndividualDetail: `${baseRoute}/reporting-portal/supplier-insights/individual-detail`,
  supplierInsightsProductDetail: `${baseRoute}/reporting-portal/supplier-insights/product-detail`,
  supplierInsightsEngagement: `${baseRoute}/reporting-portal/supplier-insights/engagement`,

  dataCollection: `${baseRoute}/data-collection`,
  dataCollectionDataEntryPlanning: `${baseRoute}/data-collection/data-entry-planning`,
  dataCollectionNewTask: `${baseRoute}/data-collection/data-entry-planning/new-task`,
  dataCollectionAddData: `${baseRoute}/data-collection/data-entry-planning/add-data`,
  dataCollectionOrganisationQuestionnaires: `${baseRoute}/data-collection/organisation-questionnaires`,
  dataCollectionTaskAssigneesTemplate: `${baseRoute}/data-collection/task-assignees-template`,

  supplierPortal: `${baseRoute}/supplier-portal`,
  [supplierAdminDashboardKey]: `${baseRoute}/supplier-portal/supplier-dashboard`,
  supplierPortalSupplierManagement: `${baseRoute}/supplier-portal/supplier-management`,
  supplierPortalDataEntryPlanning: `${baseRoute}/supplier-portal/data-entry-planning`,
  supplierPortalViewEmissions: `${baseRoute}/supplier-portal/view-emissions`,
  supplierPortalViewEngagement: `${baseRoute}/supplier-portal/view-engagement`,
  supplierPortalSupplierSettings: `${baseRoute}/supplier-portal/supplier-settings`,
  supplierPortalSupplierNotes: `${baseRoute}/supplier-portal/supplier-notes`,

  supplyChain: `${baseRoute}/supply-chain`,
  supplyChainEmissions: `${baseRoute}/supply-chain/emissions`,
  supplyChainSupplierData: `${baseRoute}/supply-chain/supplier-data`,
  supplyChainSupplierDetail: `${baseRoute}/supply-chain/supplier-data/:supplierId`,
  supplyChainSupplierTask: `${baseRoute}/supply-chain/supplier-data/:supplierId/task/:taskId`,

  csrd: `${baseRoute}/csrd`,
  csrdDataEntryPlanning: `${baseRoute}/csrd/data-entry-planning`,
  csrdQuestionnaires: `${baseRoute}/csrd/questionnaires`,
  csrdViewProgress: `${baseRoute}/csrd/view-progress`,
  csrdReport: `${baseRoute}/csrd/report`,

  knowledgeBase: `${baseRoute}/knowledge-base`,
  knowledgeBaseEsgExplorer: `${baseRoute}/knowledge-base/esg-explorer`,
  knowledgeBaseMaterialIssuesAndIndicators: `${baseRoute}/knowledge-base/material-issues-and-indicators`,
  knowledgeBaseCarbonPrice: `${baseRoute}/knowledge-base/carbon-price`,
  knowledgeBaseClimateActionTracker: `${baseRoute}/knowledge-base/climate-action-tracker`,
  knowledgeBaseClimatePolicyRadar: `${baseRoute}/knowledge-base/climate-policy-radar`,
  knowledgeBaseSustainableFinanceRegulation: `${baseRoute}/knowledge-base/sustainable-finance-regulation`,
  knowledgeBaseExposureToLitigation: `${baseRoute}/knowledge-base/exposure-to-litigation`,

  settings: `${baseRoute}/settings`,
  settingsUserManagement: `${baseRoute}/settings/user-management`,
  settingsMultimodalTransportation: `${baseRoute}/settings/multimodal-transportation`,
  settingsConversionFactors: `${baseRoute}/settings/conversion-factors`,
  settingsScopeTwoEngine: `${baseRoute}/settings/scope-two-engine`,
  settingsModelCatalog: `${baseRoute}/settings/model-catalog`,
  settingsAIUsage: `${baseRoute}/settings/ai-usage`,
  settingsAIStatus: `${baseRoute}/settings/ai-status`,
  settingsEntityManagement: `${baseRoute}/settings/entities`,
  settingsFinancialYear: `${baseRoute}/settings/financial-year`,
  settingsDimensionManagement: `${baseRoute}/settings/dimensions`,

  supplierDashboard: `${baseRoute}/supplier-dashboard`,
  supplierQuestionnaires: `${baseRoute}/supplier-questionnaires`,
  supplierQuestionnaire: `${baseRoute}/supplier-questionnaire`,
  supplierPhysicalRiskQuestionnaire: `${baseRoute}/supplier-physical-risk-questionnaire`,
  supplierNetZeroStrategy: `${baseRoute}/supplier-decarbonisation`,
  supplierNotes: `${baseRoute}/supplier-notes`,
  supplierResources: `${baseRoute}/supplier-resources`,

  supplierEmissionsReport: `${baseRoute}/supplier-emissions-report`,

  organisationQuestionnaire: `${baseRoute}/organisation-questionnaire`,
  csrdQuestionnaire: `${baseRoute}/csrd-questionnaire`,
  suppliersLocations: `${baseRoute}/suppliers-locations`,

  profile: `${baseRoute}/profile`,

  help: `${baseRoute}/help`,

  notification: `${baseRoute}/notification`,
  /** sales lead prospecting tool see IssbPlanPublic */
  esgLandscapeIssbPlanPublic: `/esg-landscape/issb-plan`,

  issbOnboarding: `${baseRoute}/issb/onboarding`,
  issbOnboardingInviteTeam: `${baseRoute}/issb/onboarding/invite-team`,
  issbDashboard: `${baseRoute}/issb/dashboard`,
  issbSources: `${baseRoute}/issb/sources`,
  issbDataInput: `${baseRoute}/issb/data-input`,
  issbQuestionnaireRound: `${baseRoute}/issb/questionnaire`,
  issbQuestionnaireRoundSetup: `${baseRoute}/issb/questionnaire/setup`,
  issbStageSetup: `${baseRoute}/issb/stage/setup`,
  issbTemplatePackage: `${baseRoute}/issb/template-package`,
  issbTemplateQuestionList: `${baseRoute}/issb/template-question`,
  issbTemplateQuestionEditor: `${baseRoute}/issb/template-question/:id`,
  aboutApp: `${baseRoute}/about-app`,
  issbAnswerDetail: `${baseRoute}/issb/data-input/answer`,

  sourcesList: `${baseRoute}/issb/sources/manage`,
  aiReview: `${baseRoute}/issb/ai-review`,
  aiTasksList: `${baseRoute}/issb/ai-tasks`,
  aiSettings: `${baseRoute}/settings/ai-settings`,
  settingsPrompts: `${baseRoute}/settings/prompts`,
  issbStartAudit: `${baseRoute}/issb/audit/start`,
  issbCloseAudit: `${baseRoute}/issb/audit/close`,
  issbCompletedAudit: `${baseRoute}/issb/audit/completed`,

  issbRequirements: `${baseRoute}/issb/requirements`,
  issbAuditControl: `${baseRoute}/issb/control`,
  issbCompareReviews: `${baseRoute}/issb/compare-reviews`,
  issbDisclosure: `${baseRoute}/issb/disclosure`,
  issbReportDoc: `${baseRoute}/issb/report-doc`,
  reportDocEditor: `${baseRoute}/issb/report-doc/editor/:id`,
  foundationData: `${baseRoute}/issb/foundation-data`,
  foundationAnswerDetail: `${baseRoute}/issb/foundation-data/answer`,
  foundationDataV2: `${baseRoute}/issb/foundation-data-v2`,
  foundationDataV2Answer: `${baseRoute}/issb/foundation-data-v2/answer`,
  foundationDataV2Chat: `${baseRoute}/issb/foundation-data-v2/chat`,
  aiDataMapping: `${baseRoute}/issb/data-mapping`,

  globalOrgManagement: `${baseRoute}/global-org-management`,
  organizationRoute: `${baseRoute}/organization/:id`,
};

/**
 * route-name -to-> list of Roles (Warning: not permissions!)
 * Roles are defined and set in Auth0 (used here via how??)
 */
export const permissions = {
  dashboard: ["ORG_ADMIN", "ORG_VIEWER"],
  [netZeroStrategyKey]: ["ORG_ADMIN"],

  reportingPortal: ["ORG_ADMIN", "ORG_VIEWER"],
  [companyEmissionsDashboardKey]: ["ORG_ADMIN", "ORG_VIEWER"],
  reportingPortalCompanyReports: ["ORG_ADMIN", "ORG_VIEWER"],
  reportingPortalPhysicalRisk: ["ORG_ADMIN", "ORG_VIEWER"],

  dataCollection: ["ORG_ADMIN", "ORG_MEMBER"],
  dataCollectionDataEntryPlanning: ["ORG_ADMIN", "ORG_MEMBER"],
  dataCollectionNewTask: ["ORG_ADMIN"],
  dataCollectionAddData: ["ORG_ADMIN"],
  dataCollectionOrganisationQuestionnaires: ["ORG_ADMIN", "ORG_MEMBER"],
  dataCollectionTaskAssigneesTemplate: ["ORG_ADMIN"],

  supplierPortal: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  [supplierAdminDashboardKey]: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplierPortalSupplierManagement: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplierPortalDataEntryPlanning: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplierPortalViewEmissions: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplierPortalViewEngagement: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplierPortalSupplierNotes: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplierPortalSupplierSettings: ["ORG_ADMIN", "SUPPLIER_ADMIN"],

  supplyChain: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplyChainEmissions: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplyChainSupplierData: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplyChainSupplierDetail: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplyChainSupplierTask: ["ORG_ADMIN", "SUPPLIER_ADMIN"],

  csrd: ["ORG_ADMIN", "CSRD_MEMBER"],
  csrdDataEntryPlanning: ["ORG_ADMIN"],
  csrdQuestionnaires: ["ORG_ADMIN", "CSRD_MEMBER"],
  csrdViewProgress: ["ORG_ADMIN", "CSRD_MEMBER"],
  csrdReport: ["ORG_ADMIN", "CSRD_MEMBER"],

  knowledgeBase: ["ORG_ADMIN", "ORG_MEMBER", "ORG_VIEWER"],
  knowledgeBaseEsgExplorer: ["ORG_ADMIN", "ORG_MEMBER", "ORG_VIEWER"],
  knowledgeBaseMaterialIssuesAndIndicators: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseCarbonPrice: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseClimateActionTracker: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseClimatePolicyRadar: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseSustainableFinanceRegulation: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseExposureToLitigation: ["ORG_ADMIN", "ORG_VIEWER"],

  settings: ["ORG_ADMIN"],
  settingsUserManagement: ["ORG_ADMIN"],
  settingsMultimodalTransportation: ["ORG_ADMIN"],
  settingsConversionFactors: ["ORG_ADMIN"],
  settingsScopeTwoEngine: ["ESG_ADMIN"],
  settingsEntityManagement: ["ORG_ADMIN"],
  settingsFinancialYear: ["ORG_ADMIN"],
  settingsDimensionManagement: ["ORG_ADMIN", "ESG_ADMIN"],
  settingsAIStatus: ["ORG_ADMIN", "ESG_ADMIN"],
  settingsGlobalOrgManagement: ["ESG_ADMIN"],
  settingsOrganization: ["ESG_ADMIN"],
  settingsPrompts: ["ESG_ADMIN"],
  settingsModelCatalog: ["ESG_ADMIN"],
  settingsAIUsage: ["ESG_ADMIN"],

  supplierDashboard: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierQuestionnaires: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierQuestionnaire: ["ORG_ADMIN", "SUPPLIER_ADMIN", "SUPPLIER", "SUPPLIER_VIEWER"],
  supplierPhysicalRiskQuestionnaire: ["ORG_ADMIN", "SUPPLIER_ADMIN", "SUPPLIER", "SUPPLIER_VIEWER"],
  supplierNetZeroStrategy: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierNotes: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierResources: ["SUPPLIER", "SUPPLIER_VIEWER"],

  organisationQuestionnaire: ["ORG_ADMIN", "ORG_MEMBER"],
  csrdQuestionnaire: ["ORG_ADMIN", "CSRD_MEMBER"],
  suppliersLocations: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],

  supplierEmissionsReport: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],

  profile: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_MEMBER", "SUPPLIER", "ORG_VIEWER", "SUPPLIER_VIEWER"],

  help: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_MEMBER", "SUPPLIER", "ORG_VIEWER", "SUPPLIER_VIEWER"],

  esgLandscapeIssbPlan: ["ORG_ADMIN", "ORG_VIEWER"],

  issbDashboard: ["ORG_ADMIN", "ORG_MEMBER"],
  foundationData: ["ORG_ADMIN", "ORG_VIEWER"],
  foundationAnswerDetail: ["ORG_ADMIN", "ORG_VIEWER"],
  // Everyone the backend lets read (`read:organization-questionnaires`). ORG_MEMBER and ESG_ADMIN were
  // missing while the page's own WRITE_ROLES listed ORG_MEMBER and the backend's write authority covered
  // them — so a member could write through the API and open the chat, but not open the page that owns
  // those affordances. Write access is gated separately, by WRITE_ROLES and by the stage/assignment rule.
  foundationDataV2: ["ORG_ADMIN", "ORG_MEMBER", "ORG_VIEWER", "ESG_ADMIN"],
  foundationDataV2Answer: ["ORG_ADMIN", "ORG_MEMBER", "ORG_VIEWER", "ESG_ADMIN"],
  // Wider than the page above, and deliberately its own key rather than reusing
  // `aiDataMapping`: saving a curated set needs the same write authority Foundation v2 itself
  // needs (update:organization-questionnaires-data, which maps to ORG_ADMIN and ORG_MEMBER), but
  // adding those roles to `aiDataMapping` would also reveal the three carbon AI Mapping buttons
  // on the Scope 1/2/3 grids, which is a change to a different feature.
  //
  // ORG_VIEWER is absent on purpose: there is nothing here for a reader. A chat session exists to
  // produce a save, and a viewer cannot save.
  foundationDataV2Chat: ["ORG_ADMIN", "ORG_MEMBER", "ESG_ADMIN"],
  // No roles required (was ["ESG_ADMIN"]) — access is gated purely by the org-level `DataMapping`
  // module flag now (config/modules.js), a deliberate call given run_python's lack of sandboxing
  // (ESG-3975) still applies to whichever user in an enabled org opens this: the module flag decides
  // WHICH orgs can use it, not who inside an enabled org can.
  aiDataMapping: [],
  issbCompareReviews: ["ESG_ADMIN"],
};

export const sideBarPages = [
  {
    name: "dashboard",
    module: "CarbonDashboard",
    linkProps: {
      to: routes.dashboard,
      icon: ChartPie,
      requiredPermissions: permissions.dashboard,
    },
    pathProps: {
      path: routes.dashboard,
      element: <Dashboard module="CarbonDashboard" componentRequiredPermissions={permissions.dashboard} />,
    },
  },
  {
    name: netZeroStrategyKey,
    module: "NetZero",
    linkProps: {
      to: routes[netZeroStrategyKey],
      icon: netZeroStrategySvgIcon,
      requiredPermissions: permissions[netZeroStrategyKey],
    },
    pathProps: {
      path: routes[netZeroStrategyKey],
      element: <NetZeroStrategy module="NetZero" componentRequiredPermissions={permissions[netZeroStrategyKey]} />,
    },
  },
  {
    name: "insights",
    module: MODULES.CarbonInsightsDashboard.id,
    mainRoute: routes.reportingPortal,
    linkProps: {
      icon: ChartBarHorizontal,
      requiredPermissions: permissions.reportingPortal,
    },
    subMenus: [
      {
        name: "reportingEmissionInsights",
        linkProps: {
          to: routes.reportingPortalInsights,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.reportingPortalCompanyReports,
        },
        pathProps: {
          path: routes.reportingPortalInsights,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <EmissionsInsights
                module="CarbonReporting"
                componentRequiredPermissions={permissions.reportingPortalCompanyReports}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "reportingSupplierInsights",
        linkProps: {
          to: routes.reportingPortalSupplierInsights,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.reportingPortalCompanyReports,
        },
        pathProps: {
          path: routes.reportingPortalSupplierInsights,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <SupplierInsights
                module="CarbonReporting"
                componentRequiredPermissions={permissions.reportingPortalCompanyReports}
              />
            </ChakraProvider>
          ),
        },
      },
    ],
  },
  {
    name: "reportingPortal",
    module: "CarbonReporting",
    mainRoute: routes.reportingPortal,
    linkProps: {
      icon: Planet,
      requiredPermissions: permissions.reportingPortal,
    },
    subMenus: [
      {
        name: companyEmissionsDashboardKey,
        linkProps: {
          to: routes[companyEmissionsDashboardKey],
          icon: BsPieChartFill,
          requiredPermissions: permissions[companyEmissionsDashboardKey],
        },
        pathProps: {
          path: routes[companyEmissionsDashboardKey],
          element: (
            <CompanyEmissionsDashboard
              module="CarbonReporting"
              componentRequiredPermissions={permissions[companyEmissionsDashboardKey]}
            />
          ),
        },
      },
      {
        name: "reportingPortalCompanyReports",
        linkProps: {
          to: routes.reportingPortalCompanyReports,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.reportingPortalCompanyReports,
        },
        pathProps: {
          path: routes.reportingPortalCompanyReports,
          element: (
            <EmissionsReports
              module="CarbonReporting"
              componentRequiredPermissions={permissions.reportingPortalCompanyReports}
            />
          ),
        },
      },
      {
        name: "reportingPortalPhysicalRisk",
        linkProps: {
          to: routes.reportingPortalPhysicalRisk,
          icon: AiFillAlert,
          requiredPermissions: permissions.reportingPortalPhysicalRisk,
        },
        pathProps: {
          path: routes.reportingPortalPhysicalRisk,
          element: (
            <PhysicalRisk
              module="CarbonReporting"
              componentRequiredPermissions={permissions.reportingPortalPhysicalRisk}
            />
          ),
        },
      },
    ],
  },
  {
    name: "dataCollection",
    module: "DataCollection",
    mainRoute: routes.dataCollection,
    linkProps: {
      icon: TreeStructure,
      requiredPermissions: permissions.dataCollection,
    },
    subMenus: [
      {
        name: "dataCollectionDataEntryPlanning",
        linkProps: {
          to: routes.dataCollectionDataEntryPlanning,
          icon: AiFillDatabase,
          requiredPermissions: permissions.dataCollectionDataEntryPlanning,
        },
        pathProps: {
          path: routes.dataCollectionDataEntryPlanning,
          element: (
            <OrganizationPlanning
              module="DataCollection"
              componentRequiredPermissions={permissions.dataCollectionDataEntryPlanning}
            />
          ),
        },
      },
      {
        name: "dataCollectionTaskAssigneesTemplate",
        linkProps: {
          to: routes.dataCollectionTaskAssigneesTemplate,
          icon: BsCollectionFill,
          requiredPermissions: permissions.dataCollectionTaskAssigneesTemplate,
        },
        pathProps: {
          path: routes.dataCollectionTaskAssigneesTemplate,
          element: (
            <TaskAssigneesTemplate
              module="DataCollection"
              componentRequiredPermissions={permissions.dataCollectionTaskAssigneesTemplate}
            />
          ),
        },
      },
    ],
  },
  {
    name: "supplierPortal",
    module: "SupplierPortal",
    mainRoute: routes.supplierPortal,
    linkProps: {
      icon: Truck,
      requiredPermissions: permissions.supplierPortal,
    },
    subMenus: [
      {
        name: supplierAdminDashboardKey,
        linkProps: {
          to: routes[supplierAdminDashboardKey],
          icon: BsPieChartFill,
          requiredPermissions: permissions[supplierAdminDashboardKey],
          group: {
            name: t("pages.dataReporting"),
            isFirstInGroup: true,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes[supplierAdminDashboardKey],
          element: (
            <SupplierAdminDashboard
              module="SupplierPortal"
              componentRequiredPermissions={permissions[supplierAdminDashboardKey]}
            />
          ),
        },
      },
      {
        name: "supplierPortalViewEmissions",
        linkProps: {
          to: routes.supplierPortalViewEmissions,
          icon: BsPassFill,
          requiredPermissions: permissions.supplierPortalViewEmissions,
          group: {
            name: t("pages.dataReporting"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalViewEmissions,
          element: (
            <SuppliersEmissionsDashboard
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalViewEmissions}
            />
          ),
        },
      },
      {
        name: "supplierPortalViewEngagement",
        linkProps: {
          to: routes.supplierPortalViewEngagement,
          icon: AiOutlineAreaChart,
          requiredPermissions: permissions.supplierPortalViewEngagement,
          group: {
            name: t("pages.dataReporting"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalViewEngagement,
          element: (
            <SupplierReports
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalViewEngagement}
            />
          ),
        },
      },
      {
        name: "supplierPortalDataEntryPlanning",
        linkProps: {
          to: routes.supplierPortalDataEntryPlanning,
          icon: AiFillDatabase,
          requiredPermissions: permissions.supplierPortalDataEntryPlanning,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: true,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalDataEntryPlanning,
          element: (
            <SuppliersPlanning
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalDataEntryPlanning}
            />
          ),
        },
      },
      {
        name: "supplierPortalSupplierManagement",
        linkProps: {
          to: routes.supplierPortalSupplierManagement,
          icon: FaUserCog,
          requiredPermissions: permissions.supplierPortalSupplierManagement,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalSupplierManagement,
          element: (
            <SupplierManagement
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalSupplierManagement}
            />
          ),
        },
      },
      {
        name: "supplierPortalSupplierNotes",
        linkProps: {
          to: routes.supplierPortalSupplierNotes,
          icon: GrNotes,
          requiredPermissions: permissions.supplierPortalSupplierNotes,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalSupplierNotes,
          element: (
            <SupplierNotes
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalSupplierNotes}
            />
          ),
        },
      },
      {
        name: "supplierPortalSupplierSettings",
        linkProps: {
          to: routes.supplierPortalSupplierSettings,
          icon: BsFillGearFill,
          requiredPermissions: permissions.supplierPortalSupplierSettings,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalSupplierSettings,
          element: (
            <SupplierSettings
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalSupplierSettings}
            />
          ),
        },
      },
    ],
  },
  {
    // New top-level "Supply Chain" section — the redesigned supplier
    // experience will be built out here. Gated behind UNDER_DEVELOPMENT so it
    // stays internal-only; move it to a proper module once it ships.
    name: "supplyChain",
    module: MODULES.UNDER_DEVELOPMENT.id,
    mainRoute: routes.supplyChain,
    linkProps: {
      icon: TreeStructure,
      requiredPermissions: permissions.supplyChain,
    },
    subMenus: [
      {
        // "Supply Chain Emissions" reuses the existing Supplier Insights page,
        // rendered at the Supply Chain route so the section stays highlighted.
        name: "supplyChainEmissions",
        linkProps: {
          to: routes.supplyChainEmissions,
          icon: AiOutlineAreaChart,
          requiredPermissions: permissions.supplyChainEmissions,
        },
        pathProps: {
          path: routes.supplyChainEmissions,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <SupplierInsights
                componentRequiredPermissions={permissions.supplyChainEmissions}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "supplyChainSupplierData",
        linkProps: {
          to: routes.supplyChainSupplierData,
          icon: AiFillDatabase,
          requiredPermissions: permissions.supplyChainSupplierData,
        },
        pathProps: {
          path: routes.supplyChainSupplierData,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <SupplierData
                componentRequiredPermissions={permissions.supplyChainSupplierData}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        // Per-supplier detail page. `hidden` keeps it out of the sidebar but
        // its route is still registered via the submenu mapping in ESGApp.
        name: "supplyChainSupplierDetail",
        hidden: true,
        linkProps: {
          to: routes.supplyChainSupplierData,
          requiredPermissions: permissions.supplyChainSupplierDetail,
        },
        pathProps: {
          path: routes.supplyChainSupplierDetail,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <SupplierDetail
                componentRequiredPermissions={permissions.supplyChainSupplierDetail}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        // Per-task data-entry page. Hidden from the sidebar; route registered
        // via the submenu mapping in ESGApp.
        name: "supplyChainSupplierTask",
        hidden: true,
        linkProps: {
          to: routes.supplyChainSupplierData,
          requiredPermissions: permissions.supplyChainSupplierTask,
        },
        pathProps: {
          path: routes.supplyChainSupplierTask,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <SupplierTaskDetail
                componentRequiredPermissions={permissions.supplyChainSupplierTask}
              />
            </ChakraProvider>
          ),
        },
      },
    ],
  },
  {
    name: "csrd",
    module: "CSRD",
    mainRoute: routes.csrd,
    linkProps: {
      icon: BsCollectionFill,
      requiredPermissions: permissions.csrd,
    },
    subMenus: [
      {
        name: "csrdDataEntryPlanning",
        linkProps: {
          to: routes.csrdDataEntryPlanning,
          icon: AiFillDatabase,
          requiredPermissions: permissions.csrdDataEntryPlanning,
        },
        pathProps: {
          path: routes.csrdDataEntryPlanning,
          element: <CSRDPlanning module="CSRD" componentRequiredPermissions={permissions.csrdDataEntryPlanning} />,
        },
      },
      {
        name: "csrdQuestionnaires",
        linkProps: {
          to: routes.csrdQuestionnaires,
          icon: BsFillBarChartFill,
          requiredPermissions: permissions.csrdQuestionnaires,
        },
        pathProps: {
          path: routes.csrdQuestionnaires,
          element: <CSRDQuestionnaires module="CSRD" componentRequiredPermissions={permissions.csrdQuestionnaires} />,
        },
      },
      {
        name: "csrdViewProgress",
        linkProps: {
          to: routes.csrdViewProgress,
          icon: RiProgress3Fill,
          requiredPermissions: permissions.csrdViewProgress,
        },
        pathProps: {
          path: routes.csrdViewProgress,
          element: <CSRDViewProgress module="CSRD" componentRequiredPermissions={permissions.csrdViewProgress} />,
        },
      },
      {
        name: "csrdReport",
        linkProps: {
          to: routes.csrdReport,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.csrdReport,
        },
        pathProps: {
          path: routes.csrdReport,
          element: <CSRDReport module="CSRD" componentRequiredPermissions={permissions.csrdReport} />,
        },
      },
    ],
  },
  // Note: Removed old KB left-hand menu as, it was nice looking content, but out of date
  {
    name: "reportingAir",
    module: "AIR",
    mainRoute: routes.issbRequirements,
    linkProps: {
      icon: NotePencil,
      requiredPermissions: permissions.issbDashboard,
    },
    subMenus: [
      {
        name: "issbDashboard",
        hidden: true,
        linkProps: {
          to: routes.issbDashboard,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
        },
        pathProps: {
          path: routes.issbDashboard,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbDashboard module="AIR" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "foundationDataV2",
        linkProps: {
          to: routes.foundationDataV2,
          icon: AiFillDatabase,
          requiredPermissions: permissions.foundationDataV2,
          // Shipped as "Foundation Data" (ESG-4024): it replaces v1 under v1's own module, so every org that
          // had v1 now gets this instead. v1's routes redirect here (see otherPages).
          requiredModules: [MODULES.FoundationData.id],
        },
        pathProps: {
          path: routes.foundationDataV2,
          element: (
            <ChakraProvider theme={EsgTheme}>
              {/* The permissions/modules on linkProps above only gate the SIDEBAR LINK. These props are
                  what gate the route itself, via WithAuthorization in the page — without them the page
                  loads for any authenticated user who knows the URL. */}
              <FoundationDataV2Page
                module={MODULES.FoundationData.id}
                componentRequiredPermissions={permissions.foundationDataV2}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        // Deep-link only: without a `?id=` there is no workstream to show, so a sidebar link would land on a
        // spinner that never resolves. Sidebar.jsx filters on `hidden`; the route stays registered.
        name: "foundationDataV2Answer",
        hidden: true,
        linkProps: {
          to: routes.foundationDataV2Answer,
          icon: AiFillDatabase,
          requiredPermissions: permissions.foundationDataV2Answer,
          requiredModules: [MODULES.FoundationData.id],
        },
        pathProps: {
          path: routes.foundationDataV2Answer,
          element: (
            <ChakraProvider theme={EsgTheme}>
              {/* linkProps gates only the sidebar link; these props gate the route itself, via
                  WithAuthorization in the page. Without them the page loads for any authenticated user who
                  knows the URL — which is what v1's foundation detail route still does. */}
              <FoundationYearDetailPage
                module={MODULES.FoundationData.id}
                componentRequiredPermissions={permissions.foundationDataV2Answer}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        // Deep-link only, for the same reason aiDataMapping is: without a `?year=` there is nothing to
        // curate, so a sidebar link would land on an empty state telling the user to go and press the
        // button they should have pressed. Sidebar.jsx filters on `hidden`; the route stays registered.
        name: "foundationDataV2Chat",
        hidden: true,
        linkProps: {
          to: routes.foundationDataV2Chat,
          icon: AiFillDatabase,
          requiredPermissions: permissions.foundationDataV2Chat,
          requiredModules: [MODULES.FoundationData.id],
        },
        pathProps: {
          path: routes.foundationDataV2Chat,
          element: (
            <ChakraProvider theme={EsgTheme}>
              {/* As above: linkProps gates only the sidebar link, these props gate the route. */}
              <FoundationChatPage
                module={MODULES.FoundationData.id}
                componentRequiredPermissions={permissions.foundationDataV2Chat}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        // Deep-link only. The bare route has no task to work against, so the sidebar link landed on an
        // empty state telling the user to use the AI Mapping button on a data grid instead — worse than
        // no link. Sidebar.jsx filters on `hidden`; the route stays registered.
        name: "aiDataMapping",
        hidden: true,
        linkProps: {
          to: routes.aiDataMapping,
          icon: AiFillDatabase,
          requiredPermissions: permissions.aiDataMapping,
          requiredModules: [MODULES.DataMapping.id],
        },
        pathProps: {
          path: routes.aiDataMapping,
          element: (
            <ChakraProvider theme={EsgTheme}>
              {/* The permissions/modules on linkProps above only gate the SIDEBAR LINK. These props are
                  what gate the route itself, via WithAuthorization in the page — without them the page
                  loaded for any authenticated user who knew the URL. Mirrors issbReportDoc below. */}
              <AiDataMappingPage
                module={MODULES.DataMapping.id}
                componentRequiredPermissions={permissions.aiDataMapping}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "issbRequirements",
        linkProps: {
          to: routes.issbRequirements,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
        },
        pathProps: {
          path: routes.issbRequirements,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbRequirementsPage module="AIR" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "Insights & Reports",
        linkProps: {
          to: routes.issbReportDoc,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
          requiredModules: [MODULES.AIReporting.id],
        },
        pathProps: {
          path: routes.issbReportDoc,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <ReportDocListPage module="AIR" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "issbAuditControl",
        hidden: true,
        linkProps: {
          to: routes.issbAuditControl,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
        },
        pathProps: {
          path: routes.issbAuditControl,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AuditControlPage module="AIR" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "issbCompareReviews",
        hidden: true,
        linkProps: {
          to: routes.issbCompareReviews,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbCompareReviews,
        },
        pathProps: {
          path: routes.issbCompareReviews,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <CompareAIReviewsPage module="AIR" componentRequiredPermissions={permissions.issbCompareReviews} />
            </ChakraProvider>
          ),
        },
      },
    ],
  },
  {
    // The Settings menu (left sidebar, but moving to top navbar)
    // TODO this should not duplicate definitions, e.g. for element.
    name: "settings",
    mainRoute: routes.settings,
    linkProps: {
      icon: GearSix,
      requiredPermissions: permissions.settings,
    },
    subMenus: [
      {
        name: "settingsUserManagement",
        linkProps: {
          to: routes.settingsUserManagement,
          icon: HiUsers,
          requiredPermissions: permissions.settingsUserManagement,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.settingsUserManagement,
          element: <Users componentRequiredPermissions={permissions.settingsUserManagement} />,
        },
      },
      {
        name: "settingsMultimodalTransportation",
        linkProps: {
          to: routes.settingsMultimodalTransportation,
          icon: FaLuggageCart,
          requiredPermissions: permissions.settingsMultimodalTransportation,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.settingsMultimodalTransportation,
          element: (
            <MultimodalTransportation componentRequiredPermissions={permissions.settingsMultimodalTransportation} />
          ),
        },
      },
      {
        name: "settingsConversionFactors",
        linkProps: {
          to: routes.settingsConversionFactors,
          icon: carbonDioxideSvgIcon,
          requiredPermissions: permissions.settingsConversionFactors,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.settingsConversionFactors,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <ConversionFactors componentRequiredPermissions={permissions.settingsConversionFactors} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsScopeTwoEngine",
        linkProps: {
          to: routes.settingsScopeTwoEngine,
          icon: carbonDioxideSvgIcon,
          requiredPermissions: permissions.settingsScopeTwoEngine,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.settingsScopeTwoEngine,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <ScopeTwoEngine componentRequiredPermissions={permissions.settingsScopeTwoEngine} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsEntityManagement",
        linkProps: {
          to: routes.settingsEntityManagement,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsEntityManagement,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.settingsEntityManagement,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <EntityPage componentRequiredPermissions={permissions.settingsEntityManagement} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsFinancialYear",
        linkProps: {
          to: routes.settingsFinancialYear,
          icon: HiMiniCalendarDays,
          requiredPermissions: permissions.settingsFinancialYear,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.settingsFinancialYear,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <FinancialYearSettings componentRequiredPermissions={permissions.settingsFinancialYear} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsDimensionManagement",
        linkProps: {
          to: routes.settingsDimensionManagement,
          icon: TreeStructure,
          requiredPermissions: permissions.settingsDimensionManagement,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.settingsDimensionManagement,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <DimensionManagementPage componentRequiredPermissions={permissions.settingsDimensionManagement} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsAIStatus",
        linkProps: {
          to: routes.settingsAIStatus,
          icon: BsFillBarChartFill,
          requiredPermissions: permissions.settingsAIStatus,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.settingsAIStatus,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AIStatus componentRequiredPermissions={permissions.settingsAIStatus} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsConfigureWorkflowStages",
        linkProps: {
          to: routes.issbStageSetup,
          icon: HiMiniSquaresPlus,
          group: { name: "settingsGroupOrganisation" },
        },
        pathProps: {
          path: routes.issbStageSetup,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbStageSetupPage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "aiSettings",
        linkProps: {
          to: routes.aiSettings,
          icon: HiMiniCog,
          requiredPermissions: permissions.settingsGlobalOrgManagement,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.aiSettings,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AISettingsPage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsPrompts",
        linkProps: {
          to: routes.settingsPrompts,
          icon: HiMiniDocumentText,
          requiredPermissions: permissions.settingsPrompts,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.settingsPrompts,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <Prompts componentRequiredPermissions={permissions.settingsPrompts} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsModelCatalog",
        linkProps: {
          to: routes.settingsModelCatalog,
          icon: HiMiniCog,
          requiredPermissions: permissions.settingsModelCatalog,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.settingsModelCatalog,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <ModelCatalog componentRequiredPermissions={permissions.settingsModelCatalog} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsAIUsage",
        linkProps: {
          to: routes.settingsAIUsage,
          icon: HiMiniCog,
          requiredPermissions: permissions.settingsAIUsage,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.settingsAIUsage,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AIUsage componentRequiredPermissions={permissions.settingsAIUsage} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "aiTasksList", // TODO move elsewhere
        linkProps: {
          to: routes.aiTasksList,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsGlobalOrgManagement,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.aiTasksList,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AITasksListPage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "issbTemplatePackage",
        linkProps: {
          to: routes.issbTemplatePackage,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsGlobalOrgManagement,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.issbTemplatePackage,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbTemplatePackagePage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "globalOrgManagement",
        linkProps: {
          to: routes.globalOrgManagement,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsGlobalOrgManagement,
          group: { name: "settingsGroupGlobalAdmin" },
        },
        pathProps: {
          path: routes.globalOrgManagement,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <OrganizationList />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsAboutApp",
        linkProps: {
          to: routes.aboutApp,
          icon: HiMiniSquaresPlus,
        },
        pathProps: {
          path: routes.aboutApp,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AboutAppPage />
            </ChakraProvider>
          ),
        },
      },
    ],
  },
  {
    name: "supplierDashboard",
    linkProps: {
      to: routes.supplierDashboard,
      icon: BsPieChartFill,
      requiredPermissions: permissions.supplierDashboard,
    },
    pathProps: {
      path: routes.supplierDashboard,
      element: <SupplierDashboard componentRequiredPermissions={permissions.supplierDashboard} />,
    },
  },
  {
    name: "supplierQuestionnaires",
    linkProps: {
      to: routes.supplierQuestionnaires,
      icon: BsFillBarChartFill,
      requiredPermissions: permissions.supplierQuestionnaires,
    },
    pathProps: {
      path: routes.supplierQuestionnaires,
      element: <SupplierQuestionnaires componentRequiredPermissions={permissions.supplierQuestionnaires} />,
    },
  },
  {
    name: "supplierNetZeroStrategy",
    linkProps: {
      to: routes.supplierNetZeroStrategy,
      icon: netZeroStrategySvgIcon,
      requiredPermissions: permissions.supplierNetZeroStrategy,
    },
    pathProps: {
      path: routes.supplierNetZeroStrategy,
      element: <SupplierNetZeroStrategy componentRequiredPermissions={permissions.supplierNetZeroStrategy} />,
    },
  },
  {
    name: "supplierNotes",
    linkProps: {
      to: routes.supplierNotes,
      icon: GrNotes,
      requiredPermissions: permissions.supplierNotes,
    },
    pathProps: {
      path: routes.supplierNotes,
      element: <SupplierUserNotes componentRequiredPermissions={permissions.supplierNotes} />,
    },
  },
  {
    name: "supplierResources",
    linkProps: {
      to: routes.supplierResources,
      icon: GoFileMedia,
      requiredPermissions: permissions.supplierResources,
    },
    pathProps: {
      path: routes.supplierResources,
      element: <SupplierResources componentRequiredPermissions={permissions.supplierResources} />,
    },
  },
  {
    // Top-level "Help" section, content-managed via the shared Prismic
    // (antaiaweb) instance used by the marketing website. No `module` gate —
    // open to every logged-in role, same as `profile`.
    name: "help",
    linkProps: {
      to: routes.help,
      icon: Question,
      requiredPermissions: permissions.help,
    },
    pathProps: {
      // Wildcard, not the bare route — HelpPage reads the article uid off the trailing path
      // segment (`/app/help/:uid`) so each article gets its own linkable/bookmarkable URL,
      // and `/app/help` alone still resolves to the Entry article. See HelpPage.jsx.
      path: `${routes.help}/*`,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <HelpPage componentRequiredPermissions={permissions.help} />
        </ChakraProvider>
      ),
    },
  },
];

export const profilePages = [
  {
    name: "profile",
    pathProps: {
      path: routes.profile,
      element: <Text>Not Implemented yet</Text>,
    },
    linkProps: {
      to: routes.profile,
      requiredPermissions: permissions.profile,
    },
  },
];

/**
 name: Not used!!
 pathProps: The props for <Route /> from "react-router-dom" 
 linkProps: Not used!! For other sets of pages, a sidebar uses linkProps. For these pages it could be dropped.
 */
export const otherPages = [
  {
    name: "dataCollectionOrganisationQuestionnairesRedirect",
    pathProps: {
      path: routes.dataCollectionOrganisationQuestionnaires,
      element: <Navigate to={routes.dataCollectionDataEntryPlanning} replace />,
    },
  },
  {
    name: "agenticDashboard",
    linkProps: {
      to: routes.agenticDashboard,
    },
    pathProps: {
      path: routes.agenticDashboard,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AgenticDashboard />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "organisationQuestionnaire",
    linkProps: {
      to: routes.organisationQuestionnaire,
      requiredPermissions: permissions.organisationQuestionnaire,
    },
    pathProps: {
      path: routes.organisationQuestionnaire,
      element: (
        <OrganizationQuestionnaireWrapper componentRequiredPermissions={permissions.organisationQuestionnaire} />
      ),
    },
  },
  {
    name: "supplierQuestionnaire",
    linkProps: {
      to: routes.supplierQuestionnaire,
      requiredPermissions: permissions.supplierQuestionnaire,
    },
    pathProps: {
      path: routes.supplierQuestionnaire,
      element: <SupplierQuestionnaire componentRequiredPermissions={permissions.supplierQuestionnaire} />,
    },
  },
  {
    name: "supplierPhysicalRiskQuestionnaire",
    linkProps: {
      to: routes.supplierPhysicalRiskQuestionnaire,
      requiredPermissions: permissions.supplierPhysicalRiskQuestionnaire,
    },
    pathProps: {
      path: routes.supplierPhysicalRiskQuestionnaire,
      element: (
        <SupplierPhysicalRiskQuestionnaire
          componentRequiredPermissions={permissions.supplierPhysicalRiskQuestionnaire}
        />
      ),
    },
  },
  {
    name: "supplierEmissionsReport",
    linkProps: {
      to: routes.supplierEmissionsReport,
      requiredPermissions: permissions.supplierEmissionsReport,
    },
    pathProps: {
      path: routes.supplierEmissionsReport,
      element: <SupplierEmissionsReport componentRequiredPermissions={permissions.supplierEmissionsReport} />,
    },
  },
  {
    name: "csrdQuestionnaire",
    linkProps: {
      to: routes.csrdQuestionnaire,
      requiredPermissions: permissions.csrdQuestionnaire,
    },
    pathProps: {
      path: routes.csrdQuestionnaire,
      element: <CSRDQuestionnaireWrapper componentRequiredPermissions={permissions.csrdQuestionnaire} />,
    },
  },
  {
    name: "suppliersLocations",
    linkProps: {
      to: routes.suppliersLocations,
      requiredPermissions: permissions.suppliersLocations,
    },
    pathProps: {
      path: routes.suppliersLocations,
      element: <SuppliersLocations componentRequiredPermissions={permissions.suppliersLocations} />,
    },
  },
  {
    name: "notifications",
    pathProps: {
      path: routes.notification,
      element: <AllNotification />,
    },
  },
  {
    name: "issbTemplatePackage",
    pathProps: {
      path: routes.issbTemplatePackage,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbTemplatePackagePage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbTemplateQuestionList",
    pathProps: {
      path: routes.issbTemplateQuestionList,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbTemplateQuestionListPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbQuestionnaireRoundSetup",
    pathProps: {
      path: routes.issbQuestionnaireRoundSetup,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbQuestionnaireRoundEditorPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbStageSetup",
    pathProps: {
      path: routes.issbStageSetup,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbStageSetupPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbAnswerDetail",
    pathProps: {
      path: routes.issbAnswerDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AnswerDetailPage />
        </ChakraProvider>
      ),
    },
  },
  /*
    Foundation Data v1 is hidden (ESG-4024): v2 ships as "Foundation Data" in its place. Both v1 routes stay
    registered so old links and bookmarks land on the v2 list rather than a 404 — the detail route to the
    list too, since a v1 question id means nothing to v2. The v1 pages and their data are kept, so restoring
    v1 is a matter of putting these elements and its sidebar entry back.
  */
  {
    name: "foundationDataRedirect",
    pathProps: {
      path: routes.foundationData,
      element: <Navigate to={routes.foundationDataV2} replace />,
    },
  },
  {
    name: "foundationAnswerDetail",
    pathProps: {
      path: routes.foundationAnswerDetail,
      element: <Navigate to={routes.foundationDataV2} replace />,
    },
  },
  {
    name: "issbOnboardingInviteTeam",
    pathProps: {
      path: routes.issbOnboardingInviteTeam,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <InviteTeamPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "sourcesList",
    pathProps: {
      path: routes.sourcesList,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SourcesListPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "aiReview",
    pathProps: {
      path: routes.aiReview,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AIReviewPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "reportDocEditor",
    pathProps: {
      path: routes.reportDocEditor,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <ReportDocEditorPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "aiTasksList",
    pathProps: {
      path: routes.aiTasksList,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AITasksListPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbDataInput",
    pathProps: {
      path: routes.issbDataInput,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <DataInputPage componentRequiredPermissions={permissions.issbDashboard} />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "dataCollectionNewTask",
    pathProps: {
      path: routes.dataCollectionNewTask,
      element: <DataEntryPlanningPage />,
    },
  },
  {
    name: "dataCollectionAddData",
    pathProps: {
      path: routes.dataCollectionAddData,
      element: <AddDataPage />,
    },
  },
  {
    name: "issbStartAudit",
    pathProps: {
      path: routes.issbStartAudit,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbStartAudit />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbCloseAudit",
    pathProps: {
      path: routes.issbCloseAudit,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbCompleteAudit />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "organization",
    pathProps: {
      path: routes.organizationRoute,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <OrganizationPage />
        </ChakraProvider>
      ),
    },
    linkProps: {
      to: routes.organizationRoute,
      requiredPermissions: permissions.settingsOrganization,
    },
  },
  {
    name: "completedAudit",
    pathProps: {
      path: routes.issbCompletedAudit,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <CompletedAuditInfo />
        </ChakraProvider>
      ),
    },
    linkProps: {
      to: routes.issbCompletedAudit,
    },
  },
  {
    name: "issbTemplateQuestionEditor",
    pathProps: {
      path: routes.issbTemplateQuestionEditor,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbTemplateQuestionEditorPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "supplierInsightEmissionDetail",
    pathProps: {
      path: routes.supplierInsightEmissionDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SupplierInsightEmissionDetail />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "supplierInsightsIndividualDetail",
    pathProps: {
      path: routes.supplierInsightsIndividualDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SupplierIndividualDetail />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "supplierInsightsProductDetail",
    pathProps: {
      path: routes.supplierInsightsProductDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SupplierProductDetail />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "supplierInsightsEngagement",
    pathProps: {
      path: routes.supplierInsightsEngagement,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SupplierEngagement />
        </ChakraProvider>
      ),
    },
  },
];

export const publicPages = [
  {
    path: routes.esgLandscapeIssbPlanPublic,
    element: <IssbPlanPublic />,
  },
];
